import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidationService } from '../register.validation';


@Component({
  selector: 'error-messages',
  templateUrl: 'error-messages.html'
})

export class ErrorMessagesComponent {
  @Input() control: FormControl;
  @Input () fontSize: string;
  constructor() { }

  get errorMessage() {
    for (let propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
        console.log(propertyName);
        return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }
    
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/app/validation/error-messages/error-messages.ts